module.exports = __webpack_public_path__ + "img/0002.9778627a.png";